export const REQUESTED = 'REQUESTED'
export const ENQUEUED = 'ENQUEUED'
export const BUILDING = 'BUILDING'
export const ERROR = 'ERROR'
export const UNKNOWN = 'UNKNOWN_ERROR'
export const WAITING_FOR_REVIEW = 'WAITING_FOR_REVIEW'
export const WAITING_TO_SEND_TO_REVIEW = 'WAITING_TO_SEND_TO_REVIEW'
export const PREPARE_FOR_SUBMISSION = 'PREPARE_FOR_SUBMISSION'
export const SENDING_TO_REVIEW = 'SENDING_TO_REVIEW'
export const MANUAL_SUBMISSION = 'MANUAL_SUBMISSION'
export const IN_REVIEW = 'IN_REVIEW'
export const REJECTED = 'REJECTED'
export const READY_FOR_SALE = 'READY_FOR_SALE'
export const WAITING_AUTH = 'WAITING_AUTH'
export const DELETE_DEV_CERTIFICATES = 'DELETE_DEV_CERTIFICATES'
export const MISSING_DEVICE = 'MISSING_DEVICE'
export const WRONG_CREDENTIALS = 'WRONG_CREDENTIALS'
export const NAME_DUPLICATED = 'NAME_DUPLICATED'
export const DD_ACCOUNT = 'DD_ACCOUNT'
export const SHARED_ACCOUNT = 'SHARED_ACCOUNT'
export const MISSING_ITC_TEAM_ID = 'MISSING_ITC_TEAM_ID'

const mapStatusApp = new Map<string, string>()

mapStatusApp.set(REQUESTED, 'Solicitado')
mapStatusApp.set(ENQUEUED, 'Aguardando compilação')
mapStatusApp.set(BUILDING, 'Compilando')
mapStatusApp.set(ERROR, 'Erro')
mapStatusApp.set(UNKNOWN, 'Erro de compilação')
mapStatusApp.set(WAITING_FOR_REVIEW, 'Aguardando revisão')
mapStatusApp.set(WAITING_TO_SEND_TO_REVIEW, 'Aguardando para enviar para revisão')
mapStatusApp.set(PREPARE_FOR_SUBMISSION, 'Aguardando processamento do aplicativo')
mapStatusApp.set(SENDING_TO_REVIEW, 'Enviando aplicativo para revisão')
mapStatusApp.set(MANUAL_SUBMISSION, 'Enviar para revisão manualmente')
mapStatusApp.set(IN_REVIEW, 'Em revisão')
mapStatusApp.set(REJECTED, 'Rejeitado')
mapStatusApp.set(READY_FOR_SALE, 'Pronto')
mapStatusApp.set(WAITING_AUTH, 'Aguardando autenticação')
mapStatusApp.set(DELETE_DEV_CERTIFICATES, 'Deletar Certificados de Desenvolvedores')
mapStatusApp.set(MISSING_DEVICE, 'Faltando adicionar dispositivo')
mapStatusApp.set(WRONG_CREDENTIALS, 'Email ou Senha incorretos')
mapStatusApp.set(NAME_DUPLICATED, 'Nome duplicado')
mapStatusApp.set(DD_ACCOUNT, 'App na Conta da ITCapital')
mapStatusApp.set(SHARED_ACCOUNT, 'App em Conta compartilhada')
mapStatusApp.set(MISSING_ITC_TEAM_ID, 'MacManaus não adicionado como desenvolvedor')

export { mapStatusApp }
